import NavLinkItem from './NavLinkItem';

export default NavLinkItem;
